export function isV3Document(document) {
    return !!(document?.envelope_id || document?.envelope?.clicksign_envelope_id);
}

export function documentApiPrefix(document) {
    return isV3Document(document) ? 'v3/documentos' : 'v1/documentos';
}

export function isV3Signer(signer) {
    return !!(signer?.envelope_id || signer?.document?.envelope_id);
}
